// extracted by mini-css-extract-plugin
export default {"product-styles__manufacturer":"product-styles__manufacturer--hCiDZ","product-styles__name":"product-styles__name--WRt3a"};